import { deleteObjective } from "src/services/api/opportunities";
import { Button, CircularProgress, Grid, Modal, Typography } from "../../basics";
import { DeleteObjectiveModalProps } from "./types";
import { useState } from "react";
import { useOpportunitiesStore } from "src/store";


const DeleteObjectiveModal = ({objectiveId, objectiveTitle, open, ...props}: DeleteObjectiveModalProps) => {

    const [loading, setLoading] = useState(false);
    const triggerRefresh = useOpportunitiesStore((s: any) => s.triggerRefresh);
    const confirmDelete = async () => {
        try{
            setLoading(true);
            await deleteObjective(objectiveId);
        }
        catch(error){
            console.error("Erro ao deletar o objetivo:", error);
        }
        finally{
            setLoading(false);
            props.onClose();
            triggerRefresh();
        }
    }
    return (
        <Modal
            {...props}
            open={open}
            size="sm"
            title="Deletar objetivo"
        >
            <Grid container direction="column" gap={2} sx={{ mt: 1 }}>
                <Typography variant="body1">
                    {`Tem certeza que deseja deletar o objetivo "${objectiveTitle}"? Esta ação não pode ser desfeita.`}
                </Typography>
                <Grid container gap={2} justifyContent="flex-end" sx={{ mt: 1 }}>
                    <Button variant="outlined" color="neutral" onClick={props.onClose} disabled={loading}>
                        <Typography>Cancelar</Typography>
                    </Button>
                    <Button
                        variant="contained"
                        onClick={confirmDelete}
                        disabled={loading}
                        sx={{
                            backgroundColor: "accentError.main",
                            "&:hover": { backgroundColor: "accentError.main", filter: "brightness(1.08)" },
                            "& .MuiTypography-root": { color: "neutral.darkest" },
                        }}
                    >
                        {loading ? (
                            <Grid container alignItems="center" gap={1}>
                                <CircularProgress size={16} color="primary" />
                                <Typography sx={{ color: "neutral.darkest" }}>Deletando...</Typography>
                            </Grid>
                        ) : (
                            <Typography sx={{ color: "neutral.darkest" }}>Deletar objetivo</Typography>
                        )}
                    </Button>
                </Grid>
            </Grid>
        </Modal>
    )
}

export { DeleteObjectiveModal }